if (!customElements.get('homepage-product-video')) {
  customElements.define(
    'homepage-product-video',
    class HomepageProductVideo extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.button = this.querySelector('[data-product-video-play]');
        this.overlay = this.querySelector('[data-product-video-overlay]');
        this.video = this.querySelector('video');

        if (!this.button || !this.overlay || !this.video) return;

        this.isInitialized = true;
        this.button.addEventListener('click', async () => {
          await this.startPlayback();
        });
      }

      async startPlayback() {
        this.button.disabled = true;
        this.video.muted = true;
        this.video.loop = false;
        this.video.controls = true;

        try {
          await this.video.play();
          this.overlay.hidden = true;
        } catch (error) {
          this.overlay.hidden = false;
        } finally {
          this.button.disabled = false;
        }
      }
    }
  );
}
